export enum HoldingsTab {
  Details = 'details',
  PortalInformation = 'portal-information',
}
